import { useBulkDelete } from '@/shared/lib';
import { positionApi, type Position } from '@/entities/Position';
import { usePositionManagement } from './usePositionManagement';

export function usePositionDelete(
  selectedCount: () => number,
  selectedPositionsArray: () => number[],
  onDeleteSuccess: (deletedIds: number[]) => void,
  removeFromSelection: (ids: number[]) => void,
  onModalClose?: () => void
) {
  const { getMultipleDeleteDescription } = usePositionManagement();

  return useBulkDelete<Position>({
    entityName: {
      singular: 'cargo',
      plural: 'cargos',
    },
    successMessage: 'Cargo excluído com sucesso.',
    successMessagePlural: 'Cargos excluídos com sucesso.',
    singleDeleteApi: positionApi.deletePosition,
    bulkDeleteApi: positionApi.bulkDelete,
    getDeleteDescription: getMultipleDeleteDescription,
    onDeleteSuccess,
    removeFromSelection,
    selectedCount,
    selectedIds: selectedPositionsArray,
    onModalClose,
  });
}
